import TaskCard from './TaskCard';

export default function CalendarDay({
  day,
  todayIso,
  selectedDate,
  tasks,
  sportMinutes,
  formatSportMinutes,
  selectedTaskIds,
  openMenuTaskId,
  parseDescriptionLines,
  onDayClick,
  onDragOver,
  onDropTask,
  onOpenSport,
  onDragStart,
  onDragEnd,
  onToggleStatus,
  onEdit,
  onToggleDescriptionCheckbox,
  onSetPriority,
  onOrderKeyDown,
  onToggleMenu,
  onToggleSelection,
  onCopyTitle,
  onPrint,
  onDelete,
  onCloseMenu,
  onOpenThemeMenu,
}) {
  const sortedTasks = [...tasks].sort(
    (first, second) =>
      (first.ordre_affichage || 9999) - (second.ordre_affichage || 9999)
  );

  return (
    <div
      className={`calendar-cell ${day.date === todayIso ? 'today-cell' : ''} ${
        tasks.length > 0 ? 'has-tasks' : ''
      } ${day.date === selectedDate ? 'selected-cell' : ''}`}
      onClick={() => onDayClick(day.date)}
      onDragOver={onDragOver}
      onDrop={() => onDropTask(day.date)}
    >
      <div className="day-header">
        <span className="day-number">
          {new Date(day.date)
            .toLocaleDateString('fr-FR', { weekday: 'long' })
            .replace(/^./, (character) => character.toUpperCase())}{' '}
          {day.day}
        </span>
      </div>

      {sportMinutes > 0 && (
        <div
          className="day-sport"
          title={`Sport : ${formatSportMinutes(sportMinutes)}`}
          onClick={(event) => {
            event.stopPropagation();
            onOpenSport();
          }}
        >
          SPORT {formatSportMinutes(sportMinutes)}
        </div>
      )}

      <div className="day-tasks">
        {sortedTasks.map((task, index) => (
          <TaskCard
            key={task.id}
            task={task}
            position={index + 1}
            isSelected={selectedTaskIds.includes(task.id)}
            isMenuOpen={openMenuTaskId === task.id}
            parseDescriptionLines={parseDescriptionLines}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onToggleStatus={onToggleStatus}
            onEdit={onEdit}
            onToggleDescriptionCheckbox={onToggleDescriptionCheckbox}
            onSetPriority={onSetPriority}
            onOrderKeyDown={onOrderKeyDown}
            onToggleMenu={onToggleMenu}
            onToggleSelection={onToggleSelection}
            onCopyTitle={onCopyTitle}
            onPrint={onPrint}
            onDelete={onDelete}
            onCloseMenu={onCloseMenu}
            onOpenThemeMenu={onOpenThemeMenu}
          />
        ))}
      </div>

      <button
        type="button"
        className="mobile-add-task-btn mobile-add-task-btn-bottom"
        onClick={(event) => {
          event.stopPropagation();
          onDayClick(day.date);
        }}
      >
        + Ajouter une tâche
      </button>
    </div>
  );
}
